{
  "growth-groot.components.email.footer.message": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.analytics.description": [
    {
      "type": 0,
      "value": "Visualize data across Atlassian products for actionable insights."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.analytics.description-appify": [
    {
      "type": 0,
      "value": "Visualize data across Atlassian apps for actionable insights."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.avocado.description": [
    {
      "type": 0,
      "value": "Question and answer."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.beacon.description": [
    {
      "type": 0,
      "value": "Security monitoring."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.bitbucket.description": [
    {
      "type": 0,
      "value": "Code management and collaboration."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.body.footer": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.body.invite-button": [
    {
      "type": 0,
      "value": "Accept Invite"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.body.product-desc.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.body.product-desc.title": [
    {
      "type": 0,
      "value": "What is "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "? "
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.body.with-reinvite": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " 3 days ago. Start collaborating with your team."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.body.without-product": [
    {
      "type": 0,
      "value": "Start planning and tracking work with "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " and your team. You can share your work and view what your team is doing."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.body.without-product-no-inviter": [
    {
      "type": 0,
      "value": "Start planning and tracking work with your team. You can share your work and view what your team is doing."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.compass.description": [
    {
      "type": 0,
      "value": "Mission control for your distributed architecture."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.confluence.description": [
    {
      "type": 0,
      "value": "A team workspace where knowledge and collaboration meet. Create, collaborate, and organize all your work in one place."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.jira-product-discovery.description": [
    {
      "type": 0,
      "value": "Jira Product Discovery is a dedicated tool for product teams to capture and prioritize ideas, connect business and tech teams, and align everyone - all in Jira."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.jira-servicedesk.description": [
    {
      "type": 0,
      "value": "IT service desk and customer service."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.jira.description": [
    {
      "type": 0,
      "value": "A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.loom.description": [
    {
      "type": 0,
      "value": "Record and share Loom videos to keep your team up to date on progress, feedback, ideas, and more."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.mercury.bodyDescription": [
    {
      "type": 0,
      "value": "Understand your company’s strategic priorities and start mapping focus areas with your team. Connect goals, work, positions, and funds to maximize your enterprise strategy."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.mercury.description": [
    {
      "type": 0,
      "value": "Define and map strategic priorities and track progress with your team."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.opsgenie.description": [
    {
      "type": 0,
      "value": "A software tool for incident management. Track on-call alerts and notifications."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.statuspage.description": [
    {
      "type": 0,
      "value": "What is Statuspage? A software tool for incident communication."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.subject": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join them in "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.subject.no-inviter": [
    {
      "type": 0,
      "value": "You're invited to collaborate in "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.subject.no-subject-name": [
    {
      "type": 0,
      "value": "You've been invited"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.subject.with-reminder": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " is waiting for you to join "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.townsquare.description": [
    {
      "type": 0,
      "value": "A software tool to connect work across your company. Share work and get aligned across teams."
    }
  ],
  "growth-groot.et-group-product-assignment.message-template.email.trello.description": [
    {
      "type": 0,
      "value": "Tasks and project management."
    }
  ],
  "growth-groot.pending-request-access-summary.message-template.in-app-notification.body.no-translate": [
    {
      "type": 1,
      "value": "body"
    }
  ],
  "growth-groot.pending-request-access-summary.message-template.in-app-notification.title.no-translate": [
    {
      "type": 0,
      "value": "Template Notification "
    },
    {
      "type": 1,
      "value": "title"
    }
  ],
  "user.access.settings.access.message.spotlight.content.body": [
    {
      "type": 0,
      "value": "Create a message that users in your organization will see when they want to request access to an app."
    }
  ],
  "user.access.settings.access.message.spotlight.content.got.it": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "user.access.settings.access.message.spotlight.content.headline": [
    {
      "type": 0,
      "value": "Create an access message"
    }
  ]
}